var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"wizard-show-more-uploads",on:{"click":_vm.handleShowMoreClick}},[_vm._v("\n    "+_vm._s(_vm.numberOfOptionalDocuments === _vm.maxNumberOfOptionalDocuments
        ? ''
        : 'Weiteres Diplom hochladen')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }